export const GET_TALENT_RESULT = 'GET_TALENT_RESULT';

export const NOT_FOUND_TALENT_RESULT = 'NOT_FOUND_TALENT_RESULT';

export const SET_SHOW_MODAL_TALENT = 'SET_SHOW_MODAL_TALENT';

export const SET_SELECT_ROLE_TALENT = 'SET_SELECT_ROLE_TALENT';

export const SET_FILTER_ROLE_TALENT = 'SET_FILTER_ROLE_TALENT';

export const SET_SHOW_ERROR_MODAL_TALENT = 'SET_SHOW_ERROR_MODAL_TALENT';

export const CLEAR_TALENT_INFO = 'CLEAR_TALENT_INFO';
